// @flow
import {useEffect, useState} from "react";
import type {Notice} from "../components/layout/InlineNotice";

/**
 * What came of the last try to redeem a coupon, held for the coupon's own notice: the store's codes
 * are reset as soon as they are read, the notice stays until the customer tries again.
 */
const useCouponNotice = (couponErrorCode: ?string, couponSuccessCode: ?string, resetCouponCodes: () => void,
                         onSettled?: () => void): [?Notice, (?Notice) => void] => {
    const [notice, setNotice] = useState(null);

    useEffect(() => {
        if (couponErrorCode) {
            // minOrderValue, invalid, expired, error, ...
            setNotice({kind: "error", text: "cart.coupon." + couponErrorCode});
        } else if (couponSuccessCode) {
            setNotice({kind: "success", text: "cart.coupon." + couponSuccessCode});
        } else {
            return;
        }
        resetCouponCodes();
        if (onSettled) onSettled();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [couponErrorCode, couponSuccessCode, resetCouponCodes]);

    return [notice, setNotice];
};

export default useCouponNotice;
